import type {
  Gallery,
  GridCell,
  GridData,
  GridDuplexCell,
  GridSingleCell,
  ImageGallery,
  VideoGallery,
} from '#src/data/data.js'

export function isSingleCell(cell: GridCell): cell is GridSingleCell {
  return 'gallery' in cell
}

export function isDuplexCell(cell: GridCell): cell is GridDuplexCell {
  return 'galleries' in cell
}

export function isImageGallery(gallery: Gallery): gallery is ImageGallery {
  return !('video' in gallery)
}

export function isVideoGallery(gallery: Gallery): gallery is VideoGallery {
  return 'video' in gallery
}

export function getGridGalleries(grid: GridData | undefined): Gallery[] {
  const galleries: Gallery[] = []
  grid?.cells.forEach(cell => {
    if (isSingleCell(cell)) {
      galleries.push(cell.gallery)
    } else if (isDuplexCell(cell)) {
      galleries.push(...cell.galleries)
    }
  })
  return galleries
}
